/**
 * Placeholder for the KiedyNabory registration v2 flow (spec
 * 2026-10-28-rejestracja-v2-z01-flaga). Rendered only behind
 * REACT_APP_KN_REGISTRATION_V2_ENABLED; later tasks fill in the screens.
 */
export const RegisterV2 = () => (
  <div className="min-h-screen bg-gray-50" data-testid="register-v2">
    <h1>Rejestracja v2 (w budowie)</h1>
  </div>
);
